<template>
  <div id="companyProfile">
    <navmenu></navmenu>
    <div class="content">
      <div class="top">
        <div class="header">
          <span class="title"> EXCELLENT ERA LENDING SERVICE CORP. </span>
        </div>
        <div class="mainText">
          <p>
            EXCELLENT ERA LENDING SERVICE CORP. is a financial technology
            (fintech) provider founded in 2019 by an experienced team with a
            vision to increase financial inclusion in the Philippines through
            the provision of short-term funding and improving people's lives.
          </p>
          <p>
            EXCELLENT ERA LENDING SERVICE CORP. aspires to contribute in
            supporting the resolution of information lending issues, especially
            those loan products that offer unreasonable interest rates and those
            that do not prioritize consumer protection. With the help of
            artificial intelligence technology, EXCELLENT ERA LENDING SERVICE
            CORP. can objectively and accurately conduct credit evaluations so
            that borrowers can be offered reasonable interest rates. In turn,
            for lenders, they have the opportunity to earn attractive returns
            based on their respective risk levels.
          </p>
          <p>
            EXCELLENT ERA LENDING SERVICE CORP. will be a trustworthy lending
            company with not only low interest rates and fees, but also
            convenient and easy transactions.
          </p>
        </div>
        <div class="info">
          <div class="left">
            <p class="title">Vision</p>
            <p>
              Improve the lives of Filipinos with easy access to short-term
              funds through attractive products.
            </p>
          </div>
          <div class="right">
            <p class="title">Mission</p>
            <p>
              Become a trusted lending company by offering friendly fees and
              attractive returns, as well as convenient and easy transactions.
            </p>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <img class="logo" src="@/assets/logo.png" alt="" />
          <p style="font-size: 18px">Providing reliable financial services</p>
          <div class="title">
            <p>Address</p>
            <p style="margin-left: 280px">Need help</p>
          </div>
          <div style="margin-top:15px">
            <img
              @click="openAddress"
              style="width: 38px; height: 38px; cursor: pointer; display: block"
              src="@/assets/addressIcon.png"
              alt=""
            />
          </div>
          <div class="about">
            <p style="margin-right: 110px">
              <span style="white-space: pre">Address:</span>
              <br />
              2806 Trade and Financial Tower， Lane Q，Bonifacio Global City，
              Taguig City，Philippines
            </p>
            <p>
              Contact us
              <br />
              Monday to Friday 8:00-18:00
              <br />
              Email: info@excellentrealending.com
              <br />
              Call center: +63 9065241087
            </p>
          </div>
          <p
            style="
              color: #fff;
              font-size: 14px;
              margin-top: 46px;
              font-family: PingFangSC, PingFang SC;
            "
          >
            Support belongs to EXCELLENT ERA LENDING SERVICE CORP.
          </p>
        </div>
        <div class="right">
          <p>Download the app now!</p>
          <div class="rightImg">
            <img style="margin-bottom: 35px" src="@/assets/google.png" alt="" />
            <img src="@/assets/appStore.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'companyProfile',
  data () {
    return {}
  },
  methods: {
    openAddress () {
      window.open('https://maps.app.goo.gl/s8Q5Z3yHPxDF5baK8')
    }
  }
}
</script>

<style scoped lang='scss'>
.content {
  background-image: url("~@/assets/eelendingBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 230px;
  padding-top: 60px;
  .top {
    width: 1220px;
    margin: auto;
    font-family: Poppins, Poppins;
    .header {
      text-align: left;
      .title {
        background-image: url("~@/assets/companyTitleBg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 22px 21px 26px;
        margin-left: 75px;
        font-size: 30px;
        color: #3d16d2;
        font-weight: bold;
      }
    }
    .mainText {
      margin-left: 75px;
      margin-top: 45px;
      p {
        font-size: 18px;
        margin-bottom: 35px;
        color: #ffffff;
        line-height: 38px;
        text-align: left;
      }
    }
    .info {
      font-family: Poppins, Poppins;
      display: flex;
      margin-left: 75px;
      width: 1100px;
      justify-content: space-between;
      margin-top: 90px;
      .title {
        text-align: center;
        color: #baff3e;
        font-size: 30px;
        font-weight: bold;
      }
      p {
        font-size: 16px;
        color: #ffffff;
        font-weight: 400;
        text-align: left;
        line-height: 32px;
        margin-top: 26px;
      }
      .left {
        background-image: url("~@/assets/vision.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 530px;
        padding: 15px 47px 45px;
      }
      .right {
        background-image: url("~@/assets/mission.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 530px;
        padding: 15px 47px 45px;
      }
    }
  }
  .bottom {
    background-image: url("~@/assets/footerBg.png");
    background-size: 100% 100%;
    width: 1310px;
    margin: auto;
    margin-top: 166px;
    text-align: left;
    color: #cff202;
    padding: 38px 52px 38px 120px;
    display: flex;
    justify-content: space-between;
    .left {
      font-family: Poppins, Poppins;
      .logo {
        background: #ffffff;
        border-radius: 37px;
        padding: 7px 0px 7px 10px;
        width: 256px;
        height: 65px;
      }
      .title {
        margin-top: 37px;
        color: #fff;
        display: flex;
        width: 660px;
        border-bottom: 1px solid #fff;
        font-size: 24px;
        padding-bottom: 15px;
      }
      .about {
        font-size: 14px;
        margin-top: 5px;
        display: flex;
        p {
          width: 270px;
          line-height: 26px;
        }
      }
    }
    .right {
      margin-top: 119px;
      font-family: Poppins, Poppins;
      font-weight: bold;
      color: #cff202;
      font-size: 30px;
      width: 375px;
      margin-right: -40px;
      .rightImg {
        margin-top: 89px;
        text-align: center;
      }
      img {
        width: 222px;
        height: 65px;
      }
    }
  }
}
</style>
